(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.customer-stories__carousel', {
      loop: false,
      initialSlide: 0,
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next-cs',
        prevEl: '.swiper-button-prev-cs',
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 20, autoHeight: false, loop: false, centeredSlides: false },
        1024: { slidesPerView: 3, spaceBetween: 24, autoHeight: false, loop: false, centeredSlides: false },
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
